module.exports = __webpack_public_path__ + "img/car_rear_left_outline.7af47884.svg";